import { useState } from "react";
// Hooks
import { useAdvisorPerformanceQuery } from "./hooks/useAdvisorPerformanceQuery";

// Helpers
import { and } from "@Common/helpers/sonar";

// Components
import { AdvisorPerformanceModelHeader } from "./components/AdvisorPerformanceModelHeader";
import { AdvisorPerformanceModelTable } from "./components/AdvisorPerformanceModelTable";

// Types
import { IPeriodTreeSelection } from "@/Layouts/components/SideBars/PayPeriodSideBar/interfaces";

interface IAdvisorPerformanceModelProps {
	selected: IPeriodTreeSelection;
	isLoading?: boolean;
	isUpdatable?: boolean;
	isTabSelected: boolean;
	hasPermission: boolean;
}

export default function AdvisorPerformanceModel(props: Readonly<IAdvisorPerformanceModelProps>) {
	const { selected, isTabSelected, hasPermission } = props;

	// States
	const [ingesting, setIngesting] = useState(false);

	// Queries
	const {
		data: advisorPerformanceResponse,
		isLoading: isAdvisorPerformanceLoading,
		hasNextPage,
	} = useAdvisorPerformanceQuery({
		enabled: and(Boolean(selected?.cycleId), Boolean(selected?.payPeriodId), isTabSelected, hasPermission),
		commissionCycleId: selected?.cycleId,
		payPeriodId: selected?.payPeriodId,
		setIngesting,
	});

	return (
		<>
			<AdvisorPerformanceModelHeader
				isLoading={isAdvisorPerformanceLoading}
				selected={selected}
				isUpdatable
				ingesting={ingesting}
				setIngesting={setIngesting}
			/>
			<AdvisorPerformanceModelTable
				hasNextPage={hasNextPage}
				data={advisorPerformanceResponse}
				isLoading={isAdvisorPerformanceLoading}
			/>
		</>
	);
}
